/**
 * BaseConfig
 * responsável
 * manter o environment
 * geral do sistema
 *
 */
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * @Injectable()
 * BaseConfig
 * (ciclo angular)
 *
 */
@Injectable()
export class BaseConfig {

  private readonly url: string;
  private readonly uriSiad: string;
  private readonly uriAscas: string;
  private readonly host: string;

  /**
   * getBaseUrlApi busca url base
   * @returns string
   */
  public getBaseUrlApi(): string {
    console.log(environment.uri);
    return environment.uri;
  }

  public getBaseUrlApiSiad(): string {
    console.log(environment.uriSiad);
    return environment.uriSiad;
  }

  public getBaseUrlApiAscas(): string {
    console.log(environment.uriAscas);
    return environment.uriAscas;
  }

  /**
   * constructor()
   * BaseConfig
   * (ciclo angular)
   */
  constructor() {
    environment.uri = this.getBaseUrlApi();
    environment.uriSiad = this.getBaseUrlApiSiad();
    environment.uriAscas = this.getBaseUrlApiAscas();
  }

  /**
    * getUrl busca url
    * @returns string
    */
  public getUrl(api: string): string {
    if (api === 'siad') {
      return environment.uriSiad;
    } else if (api === 'ascas') {
      return environment.uriAscas;
    } else {
      return environment.uri;
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/services/base-config.service.ts